module.exports = "https://r.zoocdn.com/_next/static/images/landing-pages-rural-574c9876baab3f7cddbdc0400f528ec5.svg";